import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface VoucherSectionProps {
  onOpenVoucher?: () => void
}

export const VoucherSection = ({ onOpenVoucher }: VoucherSectionProps) => {
  const { t } = useTranslation()

  return (
    <Paper
      padding={[12, 16]}
      radius="16"
    >
      <div className={s.voucherContainer}>
        <div className={s.voucherTitles}>
          <AppIcon
            id={AllIcons.FILE_WORD}
            width={24}
            height={24}
            className={s.voucherIcon}
          />
          <div>
            <p className={clsx(s.voucherTitle, 'semi-bold-14')}>
              {t('kyrgyzstan_block.voucher.title')}
            </p>
            <p className={clsx(s.voucherDescription, 'medium-13')}>
              {t('kyrgyzstan_block.voucher.description')}
            </p>
          </div>
        </div>

        <button
          onClick={onOpenVoucher}
          className={s.downloadButton}
        >
          <AppIcon
            id={AllIcons.DOWNLOAD}
            width={24}
            height={24}
            className={s.downloadIcon}
          />
        </button>
      </div>
    </Paper>
  )
}
